/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  List,
  ListItemText,
  ListItem,
  Alert,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import SendIcon from "@mui/icons-material/Send";
import { useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import api from "../../../../services/api";
import Swal from "sweetalert2";
import { inputsName } from "../../../../config/languageConst";
import { useLocation, useParams } from "react-router-dom";
import { LogTrackUser } from "../../../../types/log-track-user/log-track-user";
import Cookies from "js-cookie";
export default function Register() {
  const regex = /\W|_/;
  const [compareseourl, setcompareseourl] = useState(false);
  const [inputSEOURL, setInputSEOURL] = useState("");
  const handleChangeSEOURL = (event: any) => {
    //setMessage(event.target.value);
    setInputSEOURL(event.target.value);
  };
  useEffect(() => {
    if (regex.test(inputSEOURL)) {
      setcompareseourl(true);
    } else {
      setcompareseourl(false);
    }
  }, [inputSEOURL]);

  const [circularLoading, setCircularLoading] = useState(false);
  const [requestError, setRequestError] = useState(false);
  const [requestErrorData, setRequestErrorData] = useState([]);
  const { id } = useParams<{ id: string }>();

  //User Tracking Logging Section //////////////////////////////////////
  let [alreadySetLog, setAlreadySetLog] = useState(false);
  const location = useLocation();
  if (!alreadySetLog) {
    LogTrackUser(Cookies.get("username"), location.pathname);
    setAlreadySetLog(true as boolean);
  }
  ///////////////////////////////////////////////////////////////////
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data: any) => {
    setCircularLoading(true);

    // data.language_id = Number(data.language_id);
    // if (data.language_id !== 0) {
    //   data.language_id = Number(data.language_id);
    // }
    for (let index = 0; index < data.descriptions.length; index++) {
      data.descriptions[index].language_id = Number(
        data.descriptions[index].language_id
      );
    }

    api
      .put(`brands/${id}`, data)
      .then((response) => {
        setCircularLoading(false);
        setRequestError(false);
        Swal.fire({
          title: "Brands updated!",
          icon: "success",
          confirmButtonText: "Yes",
        });
        // reset();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
          // footer: '<a href="">Why do I have this issue?</a>',
        });
        setCircularLoading(false);
        setRequestError(false);
        setRequestErrorData(error.response.data.message);
      });
  };

  const fetchBrand = async () => {
    const response = await api.get(`brands/${id}`);
    reset(response.data);
  };
  /*   const url = window.location.href;
  const urlTranslate = url.substring(0, url.lastIndexOf("/")); */
  useEffect(() => {
    fetchBrand();
  }, []);

  return (
    <Container component="main" maxWidth="lg">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <Button
          size="large"
          variant="outlined"
          sx={{ marginTop: "10px", marginBottom: "10px" }}
          href={"/brands"}
        >
          Back
        </Button>
        <Box
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            sx={{
              fontSize: "32px",
              marginBottom: "10px",
              alignItems: "center",
              color: "#556cd6",
            }}
          >
            Edit brand {id}
          </Typography>
        </Box>
        {requestError && (
          <List component="nav" aria-label="secondary mailbox folder">
            {requestErrorData.map((error) => (
              <ListItem key={error}>
                <ListItemText
                  sx={{
                    color: "red",
                  }}
                  primary={error}
                />
              </ListItem>
            ))}
          </List>
        )}
        <Box
          component="form"
          sx={{ mt: 1, minWidth: 3 / 4, width: "100%" }}
          onSubmit={handleSubmit(onSubmit)}
        >
          <TextField
            margin="normal"
            InputLabelProps={{ shrink: true }}
            required
            fullWidth
            id="image"
            type="text"
            label="Image Address"
            {...register("image")}
            autoFocus
          />

          <p style={{ color: "red", textAlign: "center" }}>
            {errors?.image?.toString()}
          </p>

          <div style={{ marginTop: "30px" }}>
            {inputsName.map((input, index) => (
              <div
                key={index}
                className="flags-container"
                style={{ display: "block", marginTop: "50px" }}
              >
                <div className="fa-flags">
                  <img
                    src={`/assets/language/${input.language_id}.png`}
                    alt=""
                  />
                  &nbsp;-&nbsp;{input.language_name}
                </div>
                <input
                  hidden
                  {...register(`descriptions[${index}].language_id`, {})}
                  value={input.language_id}
                />
                <TextField
                  sx={{ mt: 1, minWidth: 3 / 4 }}
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  required
                  fullWidth
                  id={"#descriptions[" + index + "].name"}
                  type="text"
                  label="Name"
                  {...register(`descriptions[${index}].name`, {})}
                />
                <p style={{ color: "red", textAlign: "center" }}>
                  {errors?.descriptions?.toString()}
                </p>
                <TextField
                  sx={{ mt: 1, minWidth: 3 / 4 }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ pattern: "[-a-zA-Z0-9_-]+" }}
                  margin="normal"
                  fullWidth
                  id={"#descriptions[" + index + "].seo_url"}
                  type="text"
                  label="SEO URL (Friendly URL)"
                  {...register(`descriptions[${index}].seo_url`)}
                  onChange={handleChangeSEOURL}
                />
                {compareseourl && (
                  <Alert severity="warning">
                    Warning: caracteres specials are forbidden (Only _ and -
                    allowed)
                  </Alert>
                )}
                <p style={{ color: "red", textAlign: "center" }}>
                  {errors?.descriptions?.toString()}
                </p>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  fullWidth
                  id={"#descriptions[" + index + "].content_html"}
                  type="text"
                  label="Description (Do not use HTML format)"
                  rows={10}
                  multiline
                  {...register(`descriptions[${index}].content_html`)}
                />
                <p style={{ color: "red", textAlign: "center" }}>
                  {errors?.descriptions?.toString()}
                </p>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  fullWidth
                  id={"#descriptions[" + index + "].meta_keyword"}
                  type="text"
                  label="Meta keyword (Keywords for SEO - Write Everything related to the Brand separated by commas. Max of 2000 Characters)"
                  rows={3}
                  multiline
                  {...register(`descriptions[${index}].meta_keyword`)}
                />
                <p style={{ color: "red", textAlign: "center" }}>
                  {errors?.descriptions?.toString()}
                </p>
              </div>
            ))}
          </div>

          <Stack
            direction="row"
            spacing={2}
            sx={{
              mt: 2,
            }}
          >
            {/* <Button
                onClick={() =>
                  (window.location.href = "http://stackoverflow.com")
                }
                variant="outlined"
                startIcon={<DeleteIcon />}
              >
                Clear
              </Button> */}
            <Button
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              size="large"
              endIcon={<SendIcon />}
              disabled={circularLoading}
              type="submit"
            >
              Send
              {circularLoading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
}
